import { render } from "./TicketBuyerTypesModal.vue?vue&type=template&id=f10a3274&scoped=true"
import script from "./TicketBuyerTypesModal.vue?vue&type=script&lang=js"
export * from "./TicketBuyerTypesModal.vue?vue&type=script&lang=js"

import "./TicketBuyerTypesModal.vue?vue&type=style&index=0&id=f10a3274&lang=scss&scoped=true"

import exportComponent from "d:\\Beks\\EasyTicket\\easyticket.webshop.admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f10a3274"]])

export default __exports__